/** Command names as ДПС spells them — see ai/docs/prro-api.md. */
export const FISCAL_COMMANDS = {
  serverState: "ServerState",
  objects: "Objects",
  operators: "Operators",
  registrarState: "TransactionsRegistrarState",
  checkExt: "CheckExt",
  zReportExt: "ZRepExt",
  shifts: "Shifts",
  documents: "Documents",
  lastShiftTotals: "LastShiftTotals",
} as const;

/** DocumentRequestResultCode 2: reserved offline, not yet sent to ДПС. */
export const RESULT_CODE_OFFLINE_PENDING = "2";

export const DOC_CLASS_CHECK = "Check";

export const DOC_CLASS_Z_REPORT = "ZRep";
